import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../utils/permissions';

// Guards a standalone-route page (its own Sidebar/TopBar) behind RBAC module
// visibility. If the current role can't see `module`, redirect to /dashboard.
// `hiddenDataKey` — ixtiyoriy qo'shimcha cheklov (dataFlags.js): modul huquqi
// bo'lsa ham, shu bayroq (masalan 'sales.analytics') rolga belgilangan bo'lsa,
// SHU sahifaning o'zi alohida yopiladi (module'ning qolgan qismiga tegmaydi).
export default function RequireModule({ module, hiddenDataKey, children }) {
  const { canSeeModule, isHidden } = usePermissions();
  if (!canSeeModule(module)) return <Navigate to="/dashboard" replace />;
  if (hiddenDataKey && isHidden(hiddenDataKey)) return <Navigate to="/dashboard" replace />;
  return children;
}
